module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-29f0f4b308bc4d7e055bd42183bb7aa4.webp";